import filePhotoSvg from '@app/assets/illustrations/file-photo.svg';
import goodReviewSvg from '@app/assets/illustrations/good-review.svg';
import sadCloudSvg from '@app/assets/illustrations/sad-cloud.svg';

// Helper function to get business data from localStorage
const getBusinessData = (): { name: string; address: string } => {
  try {
    const raw = localStorage.getItem('campaignFormData');
    if (raw) {
      const parsed = JSON.parse(raw);
      return {
        name: parsed.businessName || 'Business',
        address: parsed.businessAddress || '123 Main Street, Suite 456, Anytown, USA'
      };
    }
  } catch (error) {
    console.error('Error parsing business data:', error);
  }
  return {
    name: 'Business',
    address: '123 Main Street, Suite 456, Anytown, USA'
  };
};

export const buildHtml = (inner: string) => `<!doctype html><html><head><meta charset=\"utf-8\"/><meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"/><style>
    body{font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,'Apple Color Emoji','Segoe UI Emoji';margin:0;background:#f9fafb;color:#111827}
    .card{width:100%;margin:0;background:#fff;border:none;border-radius:12px;overflow:hidden}
    .p{padding:16px}
    .center{text-align:center}
    .btn{display:flex;align-items:center;gap:8px;justify-content:center;width:100%;padding:12px 16px;border-radius:8px;color:#fff;font-weight:600;margin-top:8px}
    .divider{border-top:1px solid #e5e7eb;margin:24px 0}
    .muted{color:#6b7280;font-size:12px}
    * {box-sizing: border-box;}
    button {cursor: pointer;}
    textarea {font-family: inherit;}
  </style></head><body>${inner}</body></html>`;

export const getEmailPreviewHtml = (emailData: any) => {
  const logoUrl = emailData.logoUrl || '';
  const businessData = getBusinessData();
  const heading = emailData.heading || 'How was your experience?';
  const message = emailData.message || 'Hi {{customer-first-name}}, At {{business-name}}, we\'re always working to improve our product service, and we need your help to do just that. If you have a moment, please leave us a review by clicking below.';
  const buttonText = emailData.buttonText || 'Share feedback';
  const buttonColor = emailData.buttonColor || '#3b82f6';
  
  const inner = `
    <div class=\"card\"><div class=\"p\">
      <div style=\"max-width:450px;margin:0 auto;background:#fff;border-radius:12px;overflow:hidden;border:none;box-shadow:none\">
        <!-- Logo -->
        <div style=\"text-align:center;padding:16px 0;font-weight:600;font-size:18px;color:#6b7280\">
          ${logoUrl ? 
            `<img src="${logoUrl}" alt="Logo" style="max-width:200px;max-height:100px;object-fit:contain;" />` : 
            'LOGO'
          }
        </div>
        
        <!-- Main Content -->
        <div style=\"padding:0 16px 16px\">
          <h1 style=\"text-align:left;font-size:24px;font-weight:700;color:#111827;margin:0 0 16px 0\">${heading}</h1>
          
          ${
                message.trim()
                    .split(/\r?\n/)
                    .map((line: string) => line.trim())
                    .filter((line: string) => line !== "")
                    .map((line: string) => `<p style=\"font-size:16px;line-height:1.4;color:#374151;margin:0 0 12px 0;text-align:left\">${line}</p>`)
                    .join("\n")
          }
          
          <div style=\"text-align:center;margin:16px 0\">
            <a href="javascript:void(0)" class="button" style="color:#ffffff !important; font-weight:bold;"><button style=\"background:${buttonColor};color:#fff;padding:12px 24px;border:none;border-radius:8px;font-weight:600;font-size:16px;cursor:pointer\">${buttonText}</button>
          </div>
        </div>
        
        <!-- Footer -->
        <div style=\"padding:20px;text-align:center;">
          <p style=\"font-size:12px;color:#6b7280;margin:0 0 8px 0\">You are receiving this email because you opted in via our website.</p>
          <p style=\"font-size:12px;color:#6b7280;margin:0 0 8px 0\" id="business-address">${businessData.address}</p>
          <span style=\"color:#3b82f6;font-size:12px\" id="unsubscribe-link">Unsubscribe</span>
          <div style=\"margin-top:16px\">
            <div style=\"font-weight:600;font-size:14px;color:#6b7280;margin-bottom:4px\">${logoUrl ? 
              `<img src="${logoUrl}" alt="Logo" style="max-width:200px;max-height:100px;object-fit:contain;" />` : 
              'LOGO'
            }</div>
            <div style=\"font-size:12px;color:#9ca3af\">Powered by EchoRatings</div>
          </div>
        </div>
      </div>
    </div></div>`;
  return buildHtml(inner);
};

export const getMessagePreviewHtml = (messageData: any, businessName: string) => {
  const logoUrl = messageData.logoUrl || '';
  const businessData = getBusinessData();
  const actualBusinessName = businessName || businessData.name;
  const previewName = messageData.previewName || 'How was your experience?';
  const message = messageData.message || 'Hi, we hope you enjoyed our service! Your feedback matters to us. Please take a moment to share your thoughts and help us improve. Click {{buttonUrl}}. Thank you! - {{business-name}}';
  
  const inner = `
    <div class=\"card\"><div class=\"p\"> 
      <!-- First Header Container --> 
      <div style=\"background:#fff;padding:12px 16px;margin:0 auto 16px auto;border-radius:12px;box-shadow:0 2px 8px rgba(0,0,0,0.1);max-width:320px\"> 
        <div style=\"display:flex;align-items:center;gap:8px\"> 
          ${logoUrl ? `<img src=\"${logoUrl}\" alt=\"logo\" style=\"width:24px;height:24px;border-radius:4px;object-fit:cover\"/>` : '<div style=\"width:24px;height:24px;background:#3b82f6;border-radius:4px\"></div>'} 
          <div style=\"flex:1\"> 
            <div style=\"font-weight:600;font-size:14px;color:#111827\">${actualBusinessName}</div> 
            <div style=\"font-size:12px;color:#6b7280\">${previewName}</div> 
          </div> 
          <div style=\"font-size:12px;color:#6b7280\">1:20 PM &gt;</div> 
        </div> 
      </div>
      
      <div style=\"max-width:320px;margin:0 auto;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 4px 12px rgba(0,0,0,0.1)\"> 
        
        <!-- Centered Business Profile Header --> 
        <div style=\"background:#f3f4f6;padding:24px 16px;text-align:center;margin:8px 16px;border-radius:12px;min-height:60px\"> 
          <div style=\"display:flex;flex-direction:column;align-items:center;gap:8px\"> 
            ${logoUrl ? `<img src=\"${logoUrl}\" alt=\"logo\" style=\"width:24px;height:24px;border-radius:4px;object-fit:cover\"/>` : '<div style=\"width:24px;height:24px;background:#3b82f6;border-radius:4px\"></div>'} 
            <div style=\"font-weight:600;font-size:14px;color:#111827\">${actualBusinessName} &gt;</div> 
          </div> 
        </div> 
        
        <!-- Timestamp Separator --> 
        <div style=\"text-align:center;padding:8px 16px\"> 
          <div style=\"font-size:12px;color:#6b7280\">Yesterday 9:41</div> 
        </div> 
          
        <!-- Message Bubble --> 
        <div style=\"padding:16px\"> 
          <div style=\"background:#f3f4f6;padding:12px;border-radius:12px;font-size:14px;line-height:1.4;color:#111827\"> 
            ${message
                .replace(/{{buttonUrl}}/g, '<span style=\"color:#3b82f6;text-decoration:underline\">[Review Link]</span>')} 
          </div> 
        </div> 
      </div> 
    </div></div>`; 
  return buildHtml(inner);
};

export const getReviewPreviewHtml = (reviewData: any, businessName: string, logoUrl?: string) => {
  const businessData = getBusinessData();
  const actualBusinessName = businessName || businessData.name;
  const heading = reviewData.heading || 'Leave a review';
  const description = reviewData.description || 'How would you rate your experience with {{business-name}}?';
  
  const innerReviewHtml = `
    <!-- Header - Outside white card -->
    <div style=\"max-width:845px;margin:0 auto;background:#fff;padding:16px 80px;text-align:center;border-bottom:none;margin-bottom:16px\"> 
      <div style=\"display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:0\"> 
        ${logoUrl ? 
          `<div style=\"width:48px;height:48px;border-radius:8px;display:flex;align-items:center;justify-content:center;overflow:hidden;background:#fff\">
            <img src=\"${logoUrl}\" alt=\"Business Logo\" style=\"width:100%;height:100%;object-fit:cover;\" />
          </div>` :
          `<div style=\"width:48px;height:48px;background:#424244;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#42424414\"> 
            <span style=\"color:#424244;font-size:18px;font-weight:bold\">${actualBusinessName.charAt(0)}</span> 
          </div>`
        } 
        <div style=\"text-align:left\"> 
          <div style=\"font-size:18px;font-weight:bold;color:#111827;margin-bottom:4px\">${actualBusinessName}</div> 
          <div style=\"font-size:14px;color:#8b919f\">${businessData.address}</div> 
        </div> 
      </div> 
    </div> 
    
    <div class=\"card\"><div class=\"p\"> 
      <!-- White Content Card -->
      <div style=\"max-width:845px;margin:0 auto;background:#fff;border-radius:0;overflow:hidden;box-shadow:none\"> 
        <!-- Content --> 
        <div style=\"padding:40px 80px;text-align:left\"> 
          <h1 style=\"font-size:32px;font-weight:bold;color:#111827;margin-bottom:8px\">${heading}</h1> 
          <p style=\"font-size:16px;line-height:1.6;color:#8b919f;margin-bottom:24px\">${description}</p> 
          
          <hr style=\"border:1px solid #f6f7fa;margin:24px 0\" />
          
          <!-- Stars --> 
          <div style=\"margin-bottom:24px\"> 
            <h4 style=\"font-size:18px;font-weight:bold;color:#111827;margin-bottom:16px\">Select stars to rate</h4> 
            <div style=\"display:flex;gap:8px;justify-content:flex-start\"> 
              ${[1,2,3,4,5].map(star => `
                <div style=\"width:56px;height:56px;display:flex;align-items:center;justify-content:center;border:1px solid #f6f7fa;border-radius:4px;cursor:pointer;background:${star <= 2 ? '#f8fcff' : 'transparent'}\">
                  <svg width=\"36\" height=\"36\" viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                    <path d=\"M18 2L22.2451 12.5103L33.7063 13.5103L25.3531 21.2394L27.4902 32.4897L18 26.5103L8.50977 32.4897L10.6469 21.2394L2.29366 13.5103L13.7549 12.5103L18 2Z\" fill=\"${star <= 2 ? (reviewData.starsColor || '#52B6FE') : '#d1d5db'}\"/>
                  </svg>
            </div> 
              `).join('')} 
          </div> 
        </div> 
          
          <hr style=\"border:1px solid #f6f7fa;margin:24px 0\" />
          
          <!-- Platform Selection and AI Button Row -->
          <div style=\"display:flex;flex-direction:row;justify-content:space-between;align-items:flex-start;margin-bottom:24px;gap:16px\">
            <!-- Platform Selection --> 
            <div style=\"flex:1;display:flex;align-items:center;gap:8px\"> 
              <div style=\"display:flex;align-items:center;gap:8px;padding:12px 16px;border:1px solid #e7eaf4;border-radius:8px;background:#F6F7FA;width:fit-content\"> 
                <svg width=\"16\" height=\"14\" viewBox=\"0 0 10 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                  <path d=\"M5.68567 7.74173C5.39619 7.81623 5.09272 7.85586 4.77998 7.85586C2.77919 7.85586 1.15723 6.2339 1.15723 4.23311C1.15723 2.23231 2.77919 0.610352 4.77998 0.610352C6.62741 0.610352 8.15187 1.9932 8.37471 3.78026M1.61007 5.59164H2.66671C3.08354 5.59164 3.42145 5.25373 3.42145 4.8369V3.85574C3.42145 3.4389 3.75936 3.101 4.17619 3.101H4.93093C5.34776 3.101 5.68567 2.76309 5.68567 2.34626V1.0632M7.96785 6.50567L9.00492 6.14712C9.19931 6.07991 9.20581 5.80738 9.01484 5.73098L6.44364 4.70235C6.26478 4.63079 6.08585 4.80531 6.15293 4.9859L7.13239 7.62308C7.20396 7.81579 7.47639 7.81622 7.54857 7.62373L7.96785 6.50567Z\" stroke=\"#8B919F\" stroke-width=\"0.905689\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>
                </svg>
                <span style=\"font-size:14px;color:#505563\">Public</span> 
                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                  <path d=\"M4 6L8 10L12 6\" stroke=\"#8B919F\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>
                </svg>
              </div> 
              <svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                <path d=\"M9 9L9 12.375M9 6.49841V6.46875M2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9Z\" stroke=\"#B7BDCC\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>
              </svg>
            </div>
            
            <!-- AI Button -->
            <div style=\"margin-top:24px\">
              <button style=\"display:flex;align-items:center;gap:4px;padding:8px 12px;background:#F5F5FF;color:#5260FE;border:none;border-radius:6px;font-size:12px;font-weight:500;cursor:not-allowed;opacity:0.6\" disabled>
                <svg width=\"16\" height=\"17\" viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                  <path d=\"M12.3529 2.5L13.8782 6.62184L18 8.14706L13.8782 9.67228L12.3529 13.7941L10.8277 9.67228L6.70588 8.14706L10.8277 6.62184L12.3529 2.5Z\" fill=\"#5260FE\"/>
                  <path d=\"M5.29412 11.9118L6.62647 13.8735L8.58824 15.2059L6.62647 16.5382L5.29412 18.5L3.96176 16.5382L2 15.2059L3.96176 13.8735L5.29412 11.9118Z\" fill=\"#5260FE\"/>
                </svg>
                Improve with AI
              </button>
            </div>
          </div> 
           
          <!-- Review Input --> 
          <div style=\"margin-bottom:24px\"> 
            <label style=\"display:block;font-size:16px;font-weight:bold;color:#111827;margin-bottom:8px;text-align:left\">Review</label> 
            <div style=\"position:relative\"> 
              <textarea style=\"width:100%;padding:16px;border:1px solid #e7eaf4;border-radius:8px;resize:none;font-size:14px;line-height:1.5;min-height:120px;background:#fff\" placeholder=\"Describe your case so we can help you solve it\"></textarea> 
            </div> 
            <p style=\"font-size:10px;color:#8b919f;margin-top:8px;text-align:left\">By leaving this review, you accept our <span style=\"color:#52B6FE;font-weight:bold;cursor:pointer\">Privacy Policy</span></p> 
          </div> 
           
          <!-- Media Attachment --> 
          <div style=\"margin-bottom:24px\"> 
            <label style=\"display:block;font-size:14px;font-weight:500;color:#505563;margin-bottom:8px;text-align:left;background:#E7EAF4;padding:8px 16px;border-radius:8px;width:fit-content;cursor:pointer;display:flex;align-items:center;gap:8px\"> 
              <svg width=\"20\" height=\"21\" viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                <path d=\"M5.16428 17.9452L12.7131 10.8405L16.2655 14.3929M5.16428 17.9452H14.0452C15.5167 17.9452 16.7095 16.7524 16.7095 15.281V10.8405M5.16428 17.9452C3.69284 17.9452 2.5 16.7524 2.5 15.281V6.40001C2.5 4.92856 3.69284 3.73572 5.16428 3.73572H10.9369M15.8214 8.02382L15.8214 5.51191M15.8214 5.51191L15.8214 3M15.8214 5.51191L13.3095 5.51191M15.8214 5.51191L18.3333 5.51191M7.82857 7.73215C7.82857 8.46787 7.23215 9.06429 6.49643 9.06429C5.7607 9.06429 5.16428 8.46787 5.16428 7.73215C5.16428 6.99643 5.7607 6.40001 6.49643 6.40001C7.23215 6.40001 7.82857 6.99643 7.82857 7.73215Z\" stroke=\"#505563\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>
              </svg>
              <span style=\"font-size:14px;color:#505563\">Attach photos</span> 
            </label> 
            <p style=\"font-size:12px;color:#8b919f;margin-top:8px\">Supported formats: <strong>.jpg, .jpeg, .png, .gif, .webp.</strong></p>
            <div style=\"display:flex;gap:8px;margin-top:12px\"> 
              ${[1,2,3,4].map(() => `
                <div style=\"width:56px;height:56px;background:#f3f4f6;border-radius:4px;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden\">
                  <img src=\"${filePhotoSvg}\" alt=\"Food bowl\" style=\"width:100%;height:100%;object-fit:cover;\" />
                </div>
              `).join('')} 
            </div> 
          </div> 
           
          <!-- Submit Button --> 
          <div style=\"display:flex;flex-direction:column;gap:16px;align-items:center\">
            <button style=\"width:100%;max-width:400px;padding:10px 16px;background:${reviewData.buttonsColor || '#4285F4'};color:#fff;border:none;border-radius:8px;font-size:16px;font-weight:500;cursor:pointer;display:flex;align-items:center;justify-content:flex-start;gap:8px\"> 
              <div style=\"width:24px;height:24px;background:#fff;border-radius:4px;display:flex;align-items:center;justify-content:center;flex-shrink:0\">
                ${(() => {
                  const platform = reviewData.defaultPlatform || 'google';
                  const platformOptions = [
                    { 
                      value: 'google', 
                      label: 'Google', 
                      icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                      </svg>`
                    },
                    { 
                      value: 'yelp', 
                      label: 'Yelp', 
                      icon: `<svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3392_74753)">
                          <path d="M10.7188 16.9121L7.40046 20.953C6.93356 21.5216 7.15663 22.3801 7.84118 22.6496L11.0854 23.9265C11.7853 24.2019 12.5461 23.6984 12.566 22.9465L12.7058 17.6532C12.7341 16.5862 11.3962 16.0872 10.7188 16.9121Z" fill="#DC0000"/>
                          <path d="M10.1672 12.894L5.24589 11.1271C4.55345 10.8785 3.81981 11.3772 3.79618 12.1125L3.68418 15.5972C3.65999 16.3489 4.39005 16.8962 5.10486 16.6621L10.1371 15.0145C11.1515 14.6824 11.1718 13.2547 10.1672 12.894Z" fill="#DC0000"/>
                          <path d="M15.8073 13.463L20.8482 12.0736C21.5574 11.8781 21.8701 11.048 21.466 10.4332L19.5509 7.5198C19.1378 6.89133 18.2258 6.86428 17.7762 7.46724L14.6108 11.7121C13.9727 12.5678 14.7783 13.7466 15.8073 13.463Z" fill="#DC0000"/>
                          <path d="M12.1568 1.3459C12.1969 0.474037 11.3753 -0.183689 10.5333 0.0462587L6.5432 1.13595C5.68241 1.37102 5.31683 2.38987 5.83176 3.11861L10.4107 11.0515C10.4479 11.1159 10.4888 11.1784 10.5371 11.235C11.2152 12.0319 12.4882 11.7366 12.802 10.8038C12.8583 10.6362 12.8742 10.4576 12.8603 10.2813L12.1568 1.3459Z" fill="#DC0000"/>
                          <path d="M20.8829 17.0833L15.821 15.5291C14.8007 15.2158 13.9612 16.3708 14.5743 17.2446L17.5773 21.5251C17.9998 22.1274 18.8868 22.1427 19.3299 21.5555L21.43 18.7725C21.883 18.1721 21.6019 17.3041 20.8829 17.0833Z" fill="#DC0000"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_3392_74753">
                            <rect width="24" height="24" fill="white" transform="translate(0.666504)"/>
                          </clipPath>
                        </defs>
                      </svg>`
                    }
                  ];
                  const selectedPlatform = platformOptions.find(p => p.value === platform) || platformOptions[0];
                  return selectedPlatform.icon;
                })()}
              </div>
              <span style=\"flex:1;text-align:center\">Leave this review on ${(() => {
                const platform = reviewData.defaultPlatform || 'google';
                const platformOptions = [
                  { value: 'google', label: 'Google' },
                  { value: 'yelp', label: 'Yelp' }
                ];
                const selectedPlatform = platformOptions.find(p => p.value === platform) || platformOptions[0];
                return selectedPlatform.label;
              })()}</span>
            </button> 
          </div> 
        </div> 
      </div> 
      
      <!-- Footer -->
      <div style=\"text-align:center;padding:16px;color:#8b919f;font-size:14px\">
        Powered by <span style=\"color:#52B6FE;font-weight:bold;cursor:pointer\">Echo Ratings</span>
      </div> 
    </div></div>`; 
  return buildHtml(innerReviewHtml);
};

export const getFeedbackPreviewHtml = (feedbackData: any, businessName: string, logoUrl?: string) => {
  const businessData = getBusinessData();
  const actualBusinessName = businessName || businessData.name;
  const inputLabel = feedbackData.inputLabel || 'What can we do to improve your experience?';
  const buttonText = feedbackData.buttonText || 'Send direct feedback';
  
  const innerFeedbackHtml = `
    <!-- Header - Outside white card -->
    <div style=\"max-width:845px;margin:0 auto;background:#fff;padding:16px 80px;text-align:center;border-bottom:none;margin-bottom:16px\"> 
      <div style=\"display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:0\"> 
        ${logoUrl ? 
          `<div style=\"width:48px;height:48px;border-radius:8px;display:flex;align-items:center;justify-content:center;overflow:hidden;background:#fff\">
            <img src=\"${logoUrl}\" alt=\"Business Logo\" style=\"width:100%;height:100%;object-fit:cover;\" />
          </div>` :
          `<div style=\"width:48px;height:48px;background:#424244;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#42424414\"> 
            <span style=\"color:#424244;font-size:18px;font-weight:bold\">${actualBusinessName.charAt(0)}</span> 
          </div>`
        } 
        <div style=\"text-align:left\"> 
          <div style=\"font-size:18px;font-weight:bold;color:#111827;margin-bottom:4px\">${actualBusinessName}</div> 
          <div style=\"font-size:14px;color:#8b919f\">${businessData.address}</div> 
        </div> 
      </div> 
    </div> 
    
    <div class=\"card\"><div class=\"p\"> 
      <!-- White Content Card -->
      <div style=\"max-width:845px;margin:0 auto;background:#fff;border-radius:0;overflow:hidden;box-shadow:none\"> 
        <div style=\"padding:40px 80px;text-align:left\"> 
          <h1 style=\"font-size:32px;font-weight:bold;color:#111827;margin-bottom:8px\">Leave a review</h1> 
          <p style=\"font-size:16px;line-height:1.6;color:#8b919f;margin-bottom:24px\">How would you rate your experience with ${actualBusinessName}?</p> 
          
          <hr style=\"border:1px solid #f6f7fa;margin:24px 0\" />
           
          <!-- Stars --> 
          <div style=\"margin-bottom:24px\"> 
            <h4 style=\"font-size:18px;font-weight:bold;color:#111827;margin-bottom:16px\">Select stars to rate</h4> 
            <div style=\"display:flex;gap:8px;justify-content:flex-start\"> 
              ${[1,2,3,4,5].map(star => `
                <div style=\"width:56px;height:56px;display:flex;align-items:center;justify-content:center;border:1px solid #f6f7fa;border-radius:4px;cursor:pointer;background:${star <= 2 ? '#f8fcff' : 'transparent'}\">
                  <svg width=\"36\" height=\"36\" viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                    <path d=\"M18 2L22.2451 12.5103L33.7063 13.5103L25.3531 21.2394L27.4902 32.4897L18 26.5103L8.50977 32.4897L10.6469 21.2394L2.29366 13.5103L13.7549 12.5103L18 2Z\" fill=\"${star <= 2 ? '#52B6FE' : '#d1d5db'}\"/>
                  </svg>
                </div>
              `).join('')} 
            </div> 
          </div> 
           
          <hr style=\"border:1px solid #f6f7fa;margin:24px 0\" />
          
          <!-- Non-public Field -->
          <div style=\"margin-bottom:24px\"> 
            <div style=\"display:flex;align-items:center;gap:8px;padding:12px 16px;border:1px solid #e7eaf4;border-radius:8px;background:#F6F7FA;width:fit-content\"> 
              <svg width=\"16\" height=\"14\" viewBox=\"0 0 10 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                <path d=\"M5.68567 7.74173C5.39619 7.81623 5.09272 7.85586 4.77998 7.85586C2.77919 7.85586 1.15723 6.2339 1.15723 4.23311C1.15723 2.23231 2.77919 0.610352 4.77998 0.610352C6.62741 0.610352 8.15187 1.9932 8.37471 3.78026M1.61007 5.59164H2.66671C3.08354 5.59164 3.42145 5.25373 3.42145 4.8369V3.85574C3.42145 3.4389 3.75936 3.101 4.17619 3.101H4.93093C5.34776 3.101 5.68567 2.76309 5.68567 2.34626V1.0632M7.96785 6.50567L9.00492 6.14712C9.19931 6.07991 9.20581 5.80738 9.01484 5.73098L6.44364 4.70235C6.26478 4.63079 6.08585 4.80531 6.15293 4.9859L7.13239 7.62308C7.20396 7.81579 7.47639 7.81622 7.54857 7.62373L7.96785 6.50567Z\" stroke=\"#8B919F\" stroke-width=\"0.905689\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>
              </svg>
              <span style=\"font-size:14px;color:#505563\">Non-public</span> 
              <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                <path d=\"M4 6L8 10L12 6\" stroke=\"#8B919F\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>
              </svg>
              <svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                <path d=\"M9 9L9 12.375M9 6.49841V6.46875M2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9Z\" stroke=\"#B7BDCC\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>
              </svg>
            </div> 
          </div> 
           
          <!-- Tags Section -->
          <div style=\"margin-bottom:24px\"> 
            <h4 style=\"font-size:18px;font-weight:bold;color:#111827;margin-bottom:16px\">Select what made your experience bad</h4> 
            <div style=\"display:flex;flex-wrap:wrap;gap:8px\"> 
              ${(feedbackData.tags || []).map((tag: string) => `
                <span style=\"background:#f3f4f6;border-radius:9999px;padding:8px 12px;font-size:14px;color:#374151\">${tag}</span>
              `).join('')} 
            </div> 
          </div> 
          
          <!-- Input Label -->
          <div style=\"margin-bottom:24px\"> 
            <label style=\"display:block;font-size:16px;font-weight:bold;color:#111827;margin-bottom:8px;text-align:left\">${inputLabel}</label> 
            <textarea style=\"width:100%;padding:16px;border:1px solid #e7eaf4;border-radius:8px;resize:none;font-size:14px;line-height:1.5;min-height:120px;background:#fff\" placeholder=\"Describe your case so we can help you solve it\"></textarea> 
          </div> 
           
          <!-- Media Attachment --> 
          <div style=\"margin-bottom:24px\"> 
            <label style=\"display:block;font-size:14px;font-weight:500;color:#505563;margin-bottom:8px;text-align:left;background:#E7EAF4;padding:8px 16px;border-radius:8px;width:fit-content;cursor:pointer;display:flex;align-items:center;gap:8px\"> 
              <svg width=\"20\" height=\"21\" viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">
                <path d=\"M5.16428 17.9452L12.7131 10.8405L16.2655 14.3929M5.16428 17.9452H14.0452C15.5167 17.9452 16.7095 16.7524 16.7095 15.281V10.8405M5.16428 17.9452C3.69284 17.9452 2.5 16.7524 2.5 15.281V6.40001C2.5 4.92856 3.69284 3.73572 5.16428 3.73572H10.9369M15.8214 8.02382L15.8214 5.51191M15.8214 5.51191L15.8214 3M15.8214 5.51191L13.3095 5.51191M15.8214 5.51191L18.3333 5.51191M7.82857 7.73215C7.82857 8.46787 7.23215 9.06429 6.49643 9.06429C5.7607 9.06429 5.16428 8.46787 5.16428 7.73215C5.16428 6.99643 5.7607 6.40001 6.49643 6.40001C7.23215 6.40001 7.82857 6.99643 7.82857 7.73215Z\" stroke=\"#505563\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>
              </svg>
              <span style=\"font-size:14px;color:#505563\">Attach photos</span> 
            </label> 
            <div style=\"display:flex;gap:8px;margin-top:12px\"> 
              ${[1,2,3,4].map(() => `
                <div style=\"width:56px;height:56px;background:#f3f4f6;border-radius:4px;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden\">
                  <img src=\"${filePhotoSvg}\" alt=\"Food bowl\" style=\"width:100%;height:100%;object-fit:cover;\" />
                </div>
              `).join('')} 
            </div> 
          </div> 
           
          ${feedbackData.referenceContacts ? `
          <!-- Reference Contacts -->
          <div style=\"margin-bottom:24px\"> 
            <h4 style=\"font-size:18px;font-weight:bold;color:#111827;margin-bottom:8px\">Reference contacts <span style=\"font-weight:normal;color:#8B919F\">(Optional)</span></h4> 
            <p style=\"font-size:14px;color:#8B919F;margin-bottom:16px\">Add your contact information so that the company knows which is the best channel to contact you</p> 
            <div style=\"display:flex;gap:8px\"> 
              <input style=\"flex:1;padding:12px;border:1px solid #e7eaf4;border-radius:8px;font-size:14px;background:#F8F9FB\" placeholder=\"Email\" type=\"email\" /> 
              <div style=\"flex:1;position:relative;display:flex;align-items:center\"> 
                <div style=\"position:absolute;left:12px;display:flex;align-items:center;gap:4px;pointer-events:none;z-index:1\"> 
                  <span style=\"font-size:16px\">🇺🇸</span> 
                  <span style=\"font-size:14px;color:#374151\">+1</span> 
                </div> 
                <input style=\"width:100%;padding:12px;padding-left:60px;border:1px solid #e7eaf4;border-radius:8px;font-size:14px;background:#F8F9FB\" placeholder=\"Phone number\" type=\"tel\" /> 
              </div> 
            </div> 
          </div> 
          ` : ''}
          
          <!-- Submit Button --> 
          <div style=\"display:flex;flex-direction:column;gap:16px;align-items:center\">
            <button style=\"width:100%;max-width:400px;padding:16px;background:${feedbackData.buttonColor || '#52B6FE'};color:#fff;border:none;border-radius:8px;font-size:16px;font-weight:500;cursor:pointer\"> 
              ${buttonText}
          </button> 
        </div> 
        </div> 
        </div>
        
        <!-- Footer -->
        <div style=\"text-align:center;padding:16px;color:#8b919f;font-size:14px\">
          Powered by <span style=\"color:#52B6FE;font-weight:bold;cursor:pointer\">Echo Ratings</span>
        </div>
      </div></div>`;
  return buildHtml(innerFeedbackHtml);
};

export const getPositivePreviewHtml = (positiveData: any, businessName: string, logoUrl?: string) => {
  const businessData = getBusinessData();
  const actualBusinessName = businessName || businessData.name;
  const heading = positiveData.heading || 'Thank you for you review';
  const description = positiveData.description || 'We make it easy for your to share your exact review on our other platforms, just click the buttons below, it helps us out tremendously!';
  const additionalPlatformsTitle = positiveData.additionalPlatformsTitle || 'Leave the same review on another platforms';
  const additionalPlatformsDescription = positiveData.additionalPlatformsDescription || 'You don\'t need to re-enter anything';
  
  // Get enabled platforms
  const enabledPlatforms = Object.entries(positiveData.additionalPlatforms)
    .filter(([_, enabled]) => enabled)
    .map(([platform, _]) => platform);

  const innerPositiveHtml = `
    <div class=\"card\"><div class=\"p\">
      <div style=\"max-width:600px;margin:0 auto;background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 4px 12px rgba(0,0,0,0.1)\">
        <!-- Header - Inside white card -->
        <div style=\"background:#fff;padding:16px 24px;text-align:center;border-bottom:none\">
          <div style=\"display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:0\"> 
            ${logoUrl ? 
              `<div style=\"width:48px;height:48px;border-radius:8px;display:flex;align-items:center;justify-content:center;overflow:hidden;background:#fff\">
                <img src=\"${logoUrl}\" alt=\"Business Logo\" style=\"width:100%;height:100%;object-fit:cover;\" />
              </div>` :
              `<div style=\"width:48px;height:48px;background:#424244;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#42424414\"> 
                <span style=\"color:#424244;font-size:18px;font-weight:bold\">${actualBusinessName.charAt(0)}</span> 
              </div>`
            } 
            <div style=\"text-align:left\"> 
              <div style=\"font-size:18px;font-weight:bold;color:#111827;margin-bottom:4px\">${actualBusinessName}</div> 
              <div style=\"font-size:14px;color:#8b919f\">${businessData.address}</div> 
            </div> 
          </div> 
        </div>
        
        <!-- Content -->
        <div style=\"padding:40px 24px;text-align:center\">
          <h1 style=\"font-size:32px;font-weight:bold;color:#111827;margin-bottom:16px\">${heading}</h1>
          
          <p style=\"font-size:16px;line-height:1.6;color:#6b7280;margin-bottom:32px\">${description}</p>
          
          <!-- Illustration -->
          <div style=\"margin-bottom:32px;display:flex;justify-content:center\">
            <img src=\"${positiveData.imageUrl && positiveData.imageUrl.startsWith('data:') ? positiveData.imageUrl : goodReviewSvg}\" alt=\"Good review\" style=\"width:160px;height:160px;object-fit:contain;\" />
          </div>
          
          ${enabledPlatforms.length > 0 ? `
          <!-- Additional Platforms Section -->
          <div style=\"margin-bottom:32px\">
            <h2 style=\"font-size:24px;font-weight:bold;color:#111827;margin-bottom:8px\">${additionalPlatformsTitle}</h2>
            <p style=\"font-size:14px;color:#6b7280;margin-bottom:24px\">${additionalPlatformsDescription}</p>
            
            <div style=\"display:flex;flex-direction:column;gap:12px;max-width:400px;margin:0 auto\">
                               ${enabledPlatforms.map(platform => {
                 const platformConfig = {
                   google: {
                     name: 'Google',
                     icon: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="white"/>
                       <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="white"/>
                       <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="white"/>
                       <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="white"/>
                     </svg>`
                   },
                   yelp: {
                     name: 'Yelp',
                     icon: `<svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <g clip-path="url(#clip0_3392_74753)">
                         <path d="M10.7188 16.9121L7.40046 20.953C6.93356 21.5216 7.15663 22.3801 7.84118 22.6496L11.0854 23.9265C11.7853 24.2019 12.5461 23.6984 12.566 22.9465L12.7058 17.6532C12.7341 16.5862 11.3962 16.0872 10.7188 16.9121Z" fill="white"/>
                         <path d="M10.1672 12.894L5.24589 11.1271C4.55345 10.8785 3.81981 11.3772 3.79618 12.1125L3.68418 15.5972C3.65999 16.3489 4.39005 16.8962 5.10486 16.6621L10.1371 15.0145C11.1515 14.6824 11.1718 13.2547 10.1672 12.894Z" fill="white"/>
                         <path d="M15.8073 13.463L20.8482 12.0736C21.5574 11.8781 21.8701 11.048 21.466 10.4332L19.5509 7.5198C19.1378 6.89133 18.2258 6.86428 17.7762 7.46724L14.6108 11.7121C13.9727 12.5678 14.7783 13.7466 15.8073 13.463Z" fill="white"/>
                         <path d="M12.1568 1.3459C12.1969 0.474037 11.3753 -0.183689 10.5333 0.0462587L6.5432 1.13595C5.68241 1.37102 5.31683 2.38987 5.83176 3.11861L10.4107 11.0515C10.4479 11.1159 10.4888 11.1784 10.5371 11.235C11.2152 12.0319 12.4882 11.7366 12.802 10.8038C12.8583 10.6362 12.8742 10.4576 12.8603 10.2813L12.1568 1.3459Z" fill="white"/>
                         <path d="M20.8829 17.0833L15.821 15.5291C14.8007 15.2158 13.9612 16.3708 14.5743 17.2446L17.5773 21.5251C17.9998 22.1274 18.8868 22.1427 19.3299 21.5555L21.43 18.7725C21.883 18.1721 21.6019 17.3041 20.8829 17.0833Z" fill="white"/>
                       </g>
                       <defs>
                         <clipPath id="clip0_3392_74753">
                           <rect width="24" height="24" fill="white" transform="translate(0.666504)"/>
                         </clipPath>
                       </defs>
                     </svg>`
                   }
                 };
                
                const config = platformConfig[platform as keyof typeof platformConfig];
                if (!config) return '';
                
                               return `
                   <button style=\"width:100%;padding:16px;background:${positiveData.buttonsColor || '#3B82F6'};color:#fff;border:none;border-radius:8px;font-size:16px;font-weight:500;cursor:pointer;display:flex;align-items:center;justify-content:flex-start;gap:12px\">
                     <div style=\"width:24px;height:24px;display:flex;align-items:center;justify-content:center;flex-shrink:0\">
                       ${config.icon}
                     </div>
                     <span style=\"flex:1;text-align:center\">Leave the same review on ${config.name}</span>
                   </button>
                 `;
              }).join('')}
            </div>
          </div>
          ` : ''}
        </div>
      </div>
      
      <!-- Footer -->
      <div style=\"text-align:center;padding:16px;color:#8b919f;font-size:14px\">
        Powered by <span style=\"color:#52B6FE;font-weight:bold;cursor:pointer\">Echo Ratings</span>
      </div>
    </div></div>`;
  return buildHtml(innerPositiveHtml);
};

export const getNegativePreviewHtml = (negativeData: any, businessName: string, logoUrl?: string) => {
  const businessData = getBusinessData();
  const actualBusinessName = businessName || businessData.name;
  const heading = negativeData.heading || 'We are very sorry that you had a bad experience!';
  const description = negativeData.description || 'We will do our best to correct the negative aspects you have identified. Thank you for being transparent with us!';
  
  const innerNegativeHtml = `
    <div class=\"card\"><div class=\"p\">
      <div style=\"max-width:600px;margin:0 auto;background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 4px 12px rgba(0,0,0,0.1)\">
        <!-- Header - Inside white card -->
        <div style=\"background:#fff;padding:16px 24px;text-align:center;border-bottom:none\">
          <div style=\"display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:0\"> 
            ${logoUrl ? 
              `<div style=\"width:48px;height:48px;border-radius:8px;display:flex;align-items:center;justify-content:center;overflow:hidden;background:#fff\">
                <img src=\"${logoUrl}\" alt=\"Business Logo\" style=\"width:100%;height:100%;object-fit:cover;\" />
              </div>` :
              `<div style=\"width:48px;height:48px;background:#424244;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#42424414\"> 
                <span style=\"color:#424244;font-size:18px;font-weight:bold\">${actualBusinessName.charAt(0)}</span> 
              </div>`
            } 
            <div style=\"text-align:left\"> 
              <div style=\"font-size:18px;font-weight:bold;color:#111827;margin-bottom:4px\">${actualBusinessName}</div> 
              <div style=\"font-size:14px;color:#8b919f\">${businessData.address}</div> 
            </div> 
          </div> 
        </div>
        
        <!-- Content -->
        <div style=\"padding:40px 24px;text-align:center\">
          <h1 style=\"font-size:32px;font-weight:bold;color:#111827;margin-bottom:16px\">${heading}</h1>
          
          <p style=\"font-size:16px;line-height:1.6;color:#6b7280;margin-bottom:32px\">${description}</p>
          
          <!-- Illustration -->
          <div style=\"margin-bottom:32px;display:flex;justify-content:center\">
            <img src=\"${negativeData.imageUrl && negativeData.imageUrl.startsWith('data:') ? negativeData.imageUrl : sadCloudSvg}\" alt=\"Sad cloud\" style=\"width:187px;height:159px;object-fit:contain;\" />
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div style=\"text-align:center;padding:16px;color:#8b919f;font-size:14px\">
        Powered by <span style=\"color:#52B6FE;font-weight:bold;cursor:pointer\">Echo Ratings</span>
      </div>
    </div></div>`;
  return buildHtml(innerNegativeHtml);
};
